module.exports = {
    customer: 'mb',
    assets: { logo: 'logo.svg' }
    
};